// import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Icon from '../../wui-icon/src';
import { OperationProps } from './iTransfer';

const noop = () => {};

const defaultProps = {
    moveToLeft: noop,
    moveToRight: noop,
};

const BUTTON_TYPES = ['rightAll', 'leftOne', 'rightOne', 'leftAll'];

const TransferOperation: React.FC<OperationProps> = (props) => {
    const {
        moveToLeft = noop,
        moveToRight = noop,
        allMoveToLeft,
        allMoveToRight,
        operations,
        leftActive,
        rightActive,
        allLeftActive,
        allRightActive,
        fieldid,
        className,
        renderOperation,
    } = props;

    // useMemo缓存操作配置
    const { newOperations, buttonType } = useMemo(() => {
        if (Array.isArray(operations)) {
            const newOps: Record<string, { text: string }> = {};
            // 如果是字符串数组，按顺序映射到按钮类型
            if (operations.length > 0 && typeof operations[0] === 'string') {
                // 当只有两个字符串时，映射到rightOne和leftOne
                if (operations.length === 2) {
                    newOps.rightOne = { text: !BUTTON_TYPES.includes(operations[0]) ? operations[0] : '' };
                    newOps.leftOne = { text: !BUTTON_TYPES.includes(operations[1]) ? operations[1] : '' };
                    return { newOperations: newOps, buttonType: ['rightAll', 'leftOne', 'rightOne', 'leftAll'] };
                } else {
                    BUTTON_TYPES.forEach((type, index) => {
                        if (index < operations.length) {
                            // newOps[type] = { text: operations[index] };
                            newOps[type] = { text: '' };
                        }
                    });
                    return { newOperations: newOps, buttonType: BUTTON_TYPES };
                }
            } else {
                operations.forEach(op => {
                    newOps[op] = { text: '' };
                });
                return { newOperations: newOps, buttonType: operations };
            }
        } else {
            const newOps = operations || {};
            // 将对象转换为数组并按照 index 排序
            const entries = Object.entries(newOps);

            // 区分有 index 和没有 index 的项
            const withIndex = entries.filter(([_key, value]) => value.index !== undefined);
            const withoutIndex = entries.filter(([_key, value]) => value.index === undefined);

            // 按照 index 排序有 index 的项
            const sortedWithIndex = withIndex.sort(([_keyA, valueA], [_keyB, valueB]) =>
                (valueA.index as number) - (valueB.index as number)
            );

            // 合并排序后的项和未排序的项
            const sortedEntries = [...sortedWithIndex, ...withoutIndex];

            // 提取排序后的 keys
            const btnType = sortedEntries.length > 0 ? sortedEntries.map(([key]) => key) : BUTTON_TYPES;

            return { newOperations: newOps, buttonType: btnType };
        }
    }, [operations]);

    // useMemo缓存按钮渲染
    const sortOperations = useMemo(() => {
        const leftButtonfieldidProp = fieldid ? { fieldid: `${fieldid}_transfer-operation_left` } : {};
        const rightButtonfieldidProp = fieldid ? { fieldid: `${fieldid}_transfer-operation_right` } : {};
        const btns: Record<string, React.ReactNode> = {
            rightAll: (
                <button key="rightAll" disabled={!allRightActive} onClick={allMoveToRight} fieldid={fieldid ? `${fieldid}_transfer-operation_all_right` : undefined}>
                    <span>{newOperations?.rightAll?.text || ''}<Icon type="uf-2arrow-right" /></span>
                </button>
            ),
            leftOne: (
                <button key="leftOne" disabled={!leftActive} onClick={moveToLeft} {...leftButtonfieldidProp}>
                    <span><Icon type="uf-arrow-left" />{newOperations?.leftOne?.text || ''}</span>
                </button>
            ),
            rightOne: (
                <button key="rightOne" disabled={!rightActive} onClick={moveToRight} {...rightButtonfieldidProp}>
                    <span>{newOperations?.rightOne?.text || ''}<Icon type="uf-arrow-right" /></span>
                </button>
            ),
            leftAll: (
                <button key="leftAll" disabled={!allLeftActive} onClick={allMoveToLeft} fieldid={fieldid ? `${fieldid}_transfer-operation_all_left` : undefined}>
                    <span><Icon type="uf-2arrow-left" />{newOperations?.leftAll?.text || ''}</span>
                </button>
            ),
        };
        return buttonType.map(type => btns[type]).filter(Boolean);
    }, [
        newOperations, buttonType, allRightActive, allMoveToRight, fieldid,
        leftActive, moveToLeft, rightActive, moveToRight, allLeftActive, allMoveToLeft
    ]);

    return (
        <div className={className}>
            {sortOperations}
            {typeof renderOperation === 'function' ? renderOperation() as React.ReactNode : null}
        </div>
    );
};

TransferOperation.defaultProps = defaultProps;
export default TransferOperation;
